import React, { useState } from 'react';
import { Microscope, ClipboardList, Beaker } from 'lucide-react';
import DimensionTaskView from './DimensionTaskView';
import ResearchSubmissions from './ResearchSubmissions';

const RnDHub = ({ user }) => {
  const [activeTab, setActiveTab] = useState('tasks');

  return (
    <div className="content-area" data-testid="rnd-hub">
      {/* Header */}
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ margin: 0, fontSize: '28px', fontWeight: '700', color: 'var(--text-primary)', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Microscope size={32} color="#FF9800" />
          R&D Hub
        </h1>
        <p style={{ margin: '8px 0 0 0', color: 'var(--text-secondary)', fontSize: '14px' }}>
          Research & Development workspace - Tasks and Research Submissions
        </p>
      </div>

      {/* Tab Navigation */}
      <div style={{ display: 'flex', gap: '8px', marginBottom: '24px', borderBottom: '1px solid var(--border-color)', paddingBottom: '16px' }}>
        <button
          onClick={() => setActiveTab('tasks')}
          style={{
            padding: '12px 24px',
            border: 'none',
            borderRadius: '8px',
            background: activeTab === 'tasks' ? '#FF9800' : 'transparent',
            color: activeTab === 'tasks' ? 'white' : 'var(--text-secondary)',
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          data-testid="tab-rnd-tasks"
        >
          <ClipboardList size={18} />
          R&D Tasks
        </button>
        <button
          onClick={() => setActiveTab('research')}
          style={{
            padding: '12px 24px',
            border: 'none',
            borderRadius: '8px',
            background: activeTab === 'research' ? '#FF9800' : 'transparent',
            color: activeTab === 'research' ? 'white' : 'var(--text-secondary)',
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          data-testid="tab-research-submissions"
        >
          <Beaker size={18} />
          Research Submissions
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === 'tasks' ? (
        <DimensionTaskView
          user={user}
          dimension="rnd"
          title="R&D Tasks"
          icon={Microscope}
          color="#FF9800"
          hideHeader={true}
        />
      ) : (
        <ResearchSubmissions user={user} />
      )}
    </div>
  );
};

export default RnDHub;
